import { Badge, type Tone } from "./ui/badge";
import type { PolicyState } from "@/lib/types";
import { useTranslation } from "react-i18next";
import { useHolyModeOptional } from "@/preferences/holy-mode";
import { SacredIcon, type SacredIconName } from "./sacred-icon";

export const STATE_KEY: Record<PolicyState, string> = {
  draft: "states.draft",
  evaluating: "states.evaluating",
  scheduled: "states.scheduled",
  live: "states.live",
  superseded: "states.superseded",
  rolled_back: "states.rolled_back",
  expired: "states.expired",
  suspended: "states.suspended",
};

export const STATE_TONE: Record<PolicyState, Tone> = {
  draft: "neutral",
  evaluating: "warning",
  scheduled: "info",
  live: "success",
  superseded: "neutral",
  rolled_back: "danger",
  expired: "neutral",
  suspended: "danger",
};

export function StateBadge({ state }: { state: PolicyState }) {
  const { t } = useTranslation();
  const { enabled } = useHolyModeOptional();
  const iconByState: Record<PolicyState, SacredIconName> = {
    draft: "quill",
    evaluating: "scale",
    scheduled: "scroll",
    live: "seal",
    superseded: "book",
    rolled_back: "keys",
    expired: "scroll",
    suspended: "keys",
  };
  return <Badge tone={STATE_TONE[state] ?? "neutral"}>{enabled ? <SacredIcon name={iconByState[state]} size={13} /> : null}{STATE_KEY[state] ? t(STATE_KEY[state]) : state}</Badge>;
}
